import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/store/useApp";
import { homeRouteFor } from "@/lib/types";

/**
 * Tela para funcionário autenticado SEM nenhum acesso de back-office liberado. Não depende de permissão
 * de módulo (o próprio gate de rota a usa como destino neutro). Quando o administrador concede acessos,
 * o refresh de sessão (SessionSync) atualiza o account e este efeito leva à área autorizada — sem novo
 * login. Se a sessão cair, o botão Sair encerra.
 */
export default function NoAccess() {
  const navigate = useNavigate();
  const account = useApp((s) => s.account);
  const logout = useApp((s) => s.logout);

  useEffect(() => {
    if (!account) {
      navigate("/login", { replace: true });
      return;
    }
    const home = homeRouteFor(account);
    if (home !== "/sem-acesso") {
      navigate(home, { replace: true });
    }
  }, [account, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-background px-6">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <div className="grid h-14 w-14 place-items-center rounded-full bg-amber-500/10 text-amber-600">
          <ShieldAlert className="h-7 w-7" />
        </div>
        <h1 className="text-xl font-semibold">Você não possui acessos liberados</h1>
        <p className="text-sm text-muted-foreground">
          Sua conta ainda não tem permissões de acesso atribuídas. Entre em contato com o administrador.
          Assim que os acessos forem concedidos, esta página leva você à área autorizada automaticamente.
        </p>
        <Button
          variant="outline"
          className="gap-2"
          onClick={async () => {
            await logout();
            navigate("/login", { replace: true });
          }}
        >
          <LogOut className="h-4 w-4" /> Sair
        </Button>
      </div>
    </div>
  );
}
